<template>
    <v-container>
        <v-row>
            <v-col cols="12" md="4">
                <v-menu
                        v-model="modalDate"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                                v-model="filterDateRangeText"
                                :label="$t('dash.dateRange')"
                                readonly
                                v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                            v-model="filterDates"
                            range
                            :locale="$i18n.locale"
                            color="primary"
                            no-title
                    >
                    </v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="12" md="4">
                <v-autocomplete
                        v-if="isLoginUserSuperAdmin()"
                        v-model="organisation"
                        :items="allOrganizations"
                        item-text="name"
                        :label="$t('anOrganization')"
                        outlined
                        :no-data-text="$t('noDataAvailable')"
                        hide-details
                        return-object
                ></v-autocomplete>
                <v-checkbox
                    v-if="isLoginUserSuperAdmin()"
                    :label="$t('dash.wholeHierarchy')"
                    v-model="isSubsidiaries"
                    color="primary"
                    hide-details
                    :disabled="!organisation.id"
                ></v-checkbox>
            </v-col>
            <v-col cols="12" md="4" class="d-flex justify-end">
                <v-btn class="btn-one mr-3" height="56px"
                       @click="cancel()">
                    <span>{{ $t('cancel') }}</span>
                </v-btn>
                <v-btn class="btn-two" color="#08a657" height="56px"
                       @click="filter()">
                    <span>{{ $t('apply') }}</span>
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        components: {},
        name: "DashboardFilter",
        props: ['applyFilter', 'cancelFilter', 'allOrganizations', 'dateTimeBegin', 'dateTimeEnd', 'selectedOrganization', 'subsidiaries', 'changeSelectedSubsidiaries'],
        data() {
            return {
                organisation: {},
                modalDate: false,
                filterDates: [],
                isSubsidiaries: false
            }
        },
        computed: {
            filterDateRangeText() {
                return this.filterDates.join(' - ')
            },
        },
        methods: {
            filter() {
                if (this.filterDates.length === 2) {
                    this.applyFilter(this.filterDates[0], this.filterDates[1], this.organisation, this.isSubsidiaries)
                } else {
                    this.applyFilter('', '', this.organisation, this.isSubsidiaries)
                }

            },

            cancel() {
                this.cancelFilter();
            },

            isLoginUserSuperAdmin() {
                return localStorage.getItem('role').toLocaleLowerCase() === 'super admin' || localStorage.getItem('role').toLocaleLowerCase() === 'super admin plus'
            },

            //------------ end methods
        },
        watch: {
            dateTimeBegin() {
                this.filterDates = [this.dateTimeBegin, this.dateTimeEnd];
            },
            dateTimeEnd() {
                this.filterDates = [this.dateTimeBegin, this.dateTimeEnd];
            },
            selectedOrganization(v) {
                this.organisation = v;
            },
            subsidiaries: {
                handler(v) {
                    this.isSubsidiaries = v
                },
                immediate: true            
            },
            isSubsidiaries(v) {
                this.changeSelectedSubsidiaries(v);
            },
        },
        created() {
            this.filterDates = [this.dateTimeBegin, this.dateTimeEnd];
            this.organisation = this.selectedOrganization;
            
        },
    }
</script>